module.exports = __webpack_public_path__ + "img/shrink.9507b892.svg";